module.exports = __webpack_public_path__ + "employees-21b62107/kununuLogo-95638cc24594e9ceb45321d65d915dd3.svg";